import tools from 'tools';

export default class SmallBasket {
    constructor() {
        this.$el = $('.small-basket');
        $(document).on('custom:basketUpdate', this.update.bind(this));
    }

    update(data) {
        if (!data || !data.items) {
            return;
        }

        const count = Object.entries(data.items).length;

        const vars = {
            count: count,
            countLabel: tools.plural(count, 'товар', 'товара', 'товаров'),
            sum: data.basket.totalSum,
            minOrderSum: data.minOrderSum,
        };

        Object.entries(vars).forEach(([varName, varValue]) => this.$el.find(`[data-var=${varName}]`).html(varValue));
        $('.mobile-small-basket [data-var="count"]').html(count);
    }
}